export default __webpack_public_path__ + "static/media/responses.359bae22.svg";